var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ w250: _vm.$b.m }},_vm._l((_vm.items),function(i,n){return _c('FooterLinkItem',_vm._b({key:n},'FooterLinkItem',i,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }